module.exports = __webpack_public_path__ + "media/front/images/twitter-619b4c267e62d07a6b4bb714391be615.svg";